import { addTrack } from 'root/src/client/logic/analytics/pixel/facebookPixel'
import { gaSendEvent } from 'root/src/client/logic/analytics/googleAnalytics'

export default (value, endpointId) => {
	addTrack('Purchase', { value, currency: 'USD' })
	gaSendEvent(value, endpointId)
}
